import { OpenInNew as OpenInNewIcon } from "@mui/icons-material";
import { Button, Tooltip, Typography } from "@mui/material";
import { usePostHog } from "posthog-js/react";

import {
  ClientAppEvent,
  EVOTRUX_BLUE,
  LIGHT_GREY,
  SCHEDULE_ONBOARDING_URL,
} from "constants/index";

interface Props {
  // Distinguishes where the click originated (e.g. "trial_banner",
  // "posting_permission_modal") for product analytics.
  trackingSource: string;
  buttonSize?: "small" | "medium" | "large";
  // "onDark" renders a white button for dark backgrounds (the nav banner);
  // "onLight" renders a blue button for light backgrounds (modals).
  appearance?: "onDark" | "onLight";
}

export function BookOnboardingButton(props: Props) {
  const {
    trackingSource,
    buttonSize = "medium",
    appearance = "onLight",
  } = props;
  const posthog = usePostHog();

  const onClick = () => {
    posthog?.capture(ClientAppEvent.SHIPPER_SCHEDULE_ONBOARDING_CLICKED, {
      source: trackingSource,
    });
    window.open(SCHEDULE_ONBOARDING_URL, "_blank", "noopener,noreferrer");
  };

  const onDark = appearance === "onDark";

  return (
    <Tooltip title="Book a call with our team to get your account set up and start posting shipments.">
      <Button
        size={buttonSize}
        variant="contained"
        color="inherit"
        onClick={onClick}
        endIcon={<OpenInNewIcon sx={{ fontSize: "16px !important" }} />}
        sx={{
          backgroundColor: onDark ? "white" : EVOTRUX_BLUE,
          color: onDark ? EVOTRUX_BLUE : "white",
          textTransform: "none",
          // The nav banner squeezes its middle section on narrow screens, which
          // compressed the button until its label broke across two lines.
          flexShrink: 0,
          "&:hover": {
            backgroundColor: onDark ? LIGHT_GREY : EVOTRUX_BLUE,
          },
        }}
      >
        <Typography variant="body1" sx={{ fontWeight: "bold" }} noWrap>
          Schedule a demo
        </Typography>
      </Button>
    </Tooltip>
  );
}
